module.exports = __webpack_public_path__ + "img/project-36.9fcbe2be.png";